import { render } from "./TournamentRoomDetailView.vue?vue&type=template&id=b9c5d4ac"
import script from "./TournamentRoomDetailView.vue?vue&type=script&lang=js"
export * from "./TournamentRoomDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__